import classNames from "classnames"

export const SelectInput = ({ options = [], className, ...props }) => (
  <select
    className={classNames(
      "w-full px-2 py-1 leading-6 text-sm text-gray-600 bg-white rounded-lg border outline-none",
      className
    )}
    {...props}
  >
    {options.map((option, idx) => (
      <option key={option + idx} value={option.value}>
        {option.label}
      </option>
    ))}
  </select>
)

export default SelectInput
